import { useState } from 'react';

const ImportHolidayPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showImportPopup, setShowImportPopup] = useState<boolean>(false);

    const addToggleHandler = () => {
      setShowImportPopup(!showImportPopup);
    };

    return (
      <Component
        showImportPopup={showImportPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default ImportHolidayPopupHOC;
